import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Icon from "./Icon";

/**
 * Модалка при клике на карточку игры на посадке rublox.pro.
 *
 * 2026-06-01: упрощено.
 *   • Не залогинен — кнопки «Войти» / «Зарегистрироваться».
 *   • Залогинен   — кнопка «Играть» → /app?game=<id> (страница игры в
 *                   кабинете, как и при клике на игру из кабинета).
 *                   НЕТ кнопки «Открыть в студии» — чужие игры в студии
 *                   открывать нельзя.
 */
export default function DownloadModal({ game, onClose }) {
  const navigate = useNavigate();
  const { isAuthenticated: loggedIn } = useAuth();

  /* Закрытие по Esc + блокировка скролла фона.
     Признак «вошёл» раньше читался как `!!getToken()` — напрямую из
     localStorage, мимо AuthContext. Протухший токен там ещё лежит,
     поэтому модалка показывала «Играть», клик уводил в /app, и человека
     там разлогинивало. Теперь единый источник истины — useAuth(),
     как в Header. */
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  if (!game) return null;

  const handlePlay = () => {
    onClose();
    navigate(`/app?game=${game.id}`);
  };

  const loginNext = `/login?next=${encodeURIComponent(
    `/app?game=${game.id}`,
  )}`;
  const signupNext = `/signup?next=${encodeURIComponent(
    `/app?game=${game.id}`,
  )}`;

  return (
    <div
      className="rb-modal__overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="rb-modal" role="dialog" aria-modal="true">
        <button
          className="rb-modal__close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <Icon name="close" size={16} />
        </button>

        {game.thumbnail && (
          <div className="rb-modal__thumb">
            <img src={game.thumbnail} alt={game.title} />
          </div>
        )}

        <h3 className="rb-modal__title">{game.title}</h3>

        {loggedIn ? (
          <>
            <p className="rb-modal__text">
              Запустить игру можно прямо в браузере на странице игры в
              твоём кабинете.
            </p>
            <div className="rb-modal__actions">
              <button
                className="rb-btn rb-btn--primary rb-btn--lg rb-btn--block"
                onClick={handlePlay}
              >
                Играть
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="rb-modal__text">
              Войдите в аккаунт, чтобы играть в браузере или создавать свои
              игры в студии. Регистрация бесплатная и занимает минуту.
            </p>
            <div className="rb-modal__actions">
              <Link
                to={loginNext}
                className="rb-btn rb-btn--primary rb-btn--lg rb-btn--block"
                onClick={onClose}
              >
                Войти
              </Link>
              <Link
                to={signupNext}
                className="rb-btn rb-btn--ghost rb-btn--block"
                onClick={onClose}
              >
                Зарегистрироваться
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
